
window.addEventListener("load", function () {
        const openPopupBtn = document.getElementById('openPopupBtn');
        const closePopupBtn = document.getElementById('closePopupBtn');
        const popupOverlay = document.getElementById('popupOverlay');
        const tabs = document.querySelectorAll('.tab');
        const measurementContent = document.getElementById('measurement-content');
        const giftingContent = document.getElementById('gifting-content');
        const cmRadio = document.getElementById('cm');
        const inchesRadio = document.getElementById('inches');
        const sizeTableBody = document.getElementById('size-table-body');

        // Open popup
        openPopupBtn.addEventListener('click', function() {
            popupOverlay.classList.remove('hidden');
            document.body.style.overflow = 'hidden'; 
        });

        // Close popup
        closePopupBtn.addEventListener('click', function() {
            popupOverlay.classList.add('hidden');
            document.body.style.overflow = 'auto'; 
        });

        // Close popup when clicking outside
        popupOverlay.addEventListener('click', function(e) {
            if (e.target === popupOverlay) {
                popupOverlay.classList.add('hidden');
                document.body.style.overflow = 'auto';
            }
        });

        // Tab switching
        tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => t.classList.remove('active'));
                this.classList.add('active');

                const tabName = this.getAttribute('data-tab');
                
                if (tabName === 'measurement') {
                    measurementContent.classList.remove('hidden');
                    giftingContent.classList.add('hidden');
                } else if (tabName === 'gifting') {
                    measurementContent.classList.add('hidden');
                    giftingContent.classList.remove('hidden');
                }
            });
        });

        // Unit conversion function
        function updateTableValues(unit) {
            const rows = sizeTableBody.querySelectorAll('tr');
            rows.forEach(row => {
                const cell = row.querySelector('td:last-child');
                if (unit === 'cm') {
                    const cmValue = cell.getAttribute('data-cm');
                    cell.textContent = cmValue + ' cm';
                } else {
                    const inchValue = cell.getAttribute('data-inches');
                    cell.textContent = inchValue + '"';
                }
            });
        }

        // Radio button change listeners
        cmRadio.addEventListener('change', function() {
            if (this.checked) {
                updateTableValues('cm');
            }
        });

        inchesRadio.addEventListener('change', function() {
            if (this.checked) {
                updateTableValues('inches');
            }
        });
});

